import axios from "axios";
import type firebase from "firebase/app";

export enum FirebaseShard {
  Customer = "customer",
  Tracing = "tracing",
}

export type firebase = typeof firebase;

export const createFirebaseWrapper = (firebaseInstance: firebase) => {
  const getDatabaseUrl = (shard?: string) => {
    const projectId = (firebaseInstance.app().options as { projectId: string })
      .projectId;
    return `https://${projectId}${shard ? `-${shard}` : ""}.firebaseio.com`;
  };
  const database = (shard: FirebaseShard) => {
    if (shard === undefined) throw new Error("Shard not defined");
    const url = getDatabaseUrl(shard);
    const shardDatabase = firebaseInstance.app().database(url);

    const getKeysAtPath = async (path: string) => {
      const idToken = await firebaseInstance.auth().currentUser?.getIdToken();
      const result = await axios({
        method: "GET",
        url: `${url}/${path}.json`,
        params: {
          auth: idToken,
          shallow: true,
        },
      });
      return Object.keys(result.data || {}).sort();
    };
    return {
      ref: shardDatabase.ref.bind(shardDatabase),
      getKeysAtPath: getKeysAtPath,
    };
  };
  return {
    auth: firebaseInstance.auth,
    function: (name: string): FunctionCall => ({
      name: name,
      action: firebaseInstance.functions().httpsCallable(name),
    }),
    shards: FirebaseShard,
    database: database,
  };
};
export interface FunctionCall {
  name: string;
  action: firebase.functions.HttpsCallable;
}
